/* Bitronics · home nueva
   Cada pieza se arranca sobre su propio elemento y deja una funcion para pararse,
   asi el editor de Shopify puede recargar una seccion sin duplicar relojes. */
(function () {
  if (window.BTHome) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esMovil = function () { return window.matchMedia('(max-width: 680px)').matches; };
  var arr = function (list) { return Array.prototype.slice.call(list); };
  var aLaVista = function (el, alto) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * (alto || 0.85) && r.bottom > 60;
  };

  /* ---------- banner rotativo ---------- */
  function banner(rot) {
    var slides = arr(rot.querySelectorAll('.bt-slide'));
    var dots = arr(rot.querySelectorAll('.bt-rot-dots button'));
    if (!slides.length) return null;
    var i = 0, timer = null;
    var pausa = parseInt(rot.getAttribute('data-pausa') || '8500', 10);

    function go(n) {
      i = n;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === n); });
      dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === n ? 'true' : 'false'); });
    }
    function parar() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); parar(); }); });

    // los slides comparten celda: el carrusel toma la altura del texto mas largo, asi no salta al rotar
    function igualar() {
      rot.style.minHeight = '';
      var alto = 0;
      slides.forEach(function (s) {
        var tenia = s.classList.contains('on'), vis = s.style.visibility;
        if (!tenia) { s.style.visibility = 'hidden'; s.classList.add('on'); }
        var t = s.querySelector('.bt-slide-in');
        if (t) alto = Math.max(alto, t.offsetHeight);
        if (!tenia) { s.classList.remove('on'); s.style.visibility = vis; }
      });
      if (alto) rot.style.minHeight = alto + 'px';
    }
    igualar();
    window.addEventListener('resize', igualar);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(igualar);

    // en el editor, al pinchar un slide se queda a la vista
    function alElegir(e) { var k = slides.indexOf(e.target); if (k > -1) { go(k); parar(); } }
    rot.addEventListener('shopify:block:select', alElegir);

    if (!reduce && slides.length > 1) timer = setInterval(function () { go((i + 1) % slides.length); }, pausa);
    return function () { parar(); window.removeEventListener('resize', igualar); };
  }

  /* ---------- video: los clips se pasan el turno y cambia la etiqueta ---------- */
  function relevo(caja) {
    var clips = arr(caja.querySelectorAll('.bt-clip'));
    var vids = clips.map(function (c) { return c.querySelector('video'); });
    if (!clips.length || vids.some(function (v) { return !v; })) return null;
    var tag = caja.querySelector('.bt-loop-tag');
    var i = 0, reloj = null, cambio = null;
    vids.forEach(function (v) {
      v.muted = true; v.playsInline = true; v.controls = false; v.loop = vids.length === 1;
      v.setAttribute('muted', ''); v.removeAttribute('controls');
    });
    clips.forEach(function (c, k) { c.classList.toggle('on', k === 0); });
    if (tag) tag.textContent = clips[0].getAttribute('data-nombre') || '';
    if (vids[1]) vids[1].preload = 'auto';

    function arranca(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function programa() {
      clearTimeout(reloj);
      if (vids.length < 2) return;
      var v = vids[i];
      var falta = (isFinite(v.duration) ? v.duration : 21) - (v.currentTime || 0);
      // respaldo por si el navegador no avisa del final
      reloj = setTimeout(pasa, Math.max(1200, falta * 1000 + 250));
    }
    function pasa() {
      var previo = i;
      i = (i + 1) % vids.length;
      var sig = vids[i];
      sig.currentTime = 0;
      arranca(sig);
      clips[i].classList.add('on');
      clips[previo].classList.remove('on');
      var siguiente = vids[(i + 1) % vids.length];
      if (siguiente) siguiente.preload = 'auto';
      if (tag) {
        tag.style.opacity = '0';
        clearTimeout(cambio);
        cambio = setTimeout(function () { tag.textContent = clips[i].getAttribute('data-nombre') || ''; tag.style.opacity = '1'; }, 350);
      }
      setTimeout(function () { if (i !== previo) vids[previo].pause(); }, 800);
      programa();
    }
    vids.forEach(function (v, k) {
      v.addEventListener('ended', function () { if (k === i) pasa(); });
      v.addEventListener('loadedmetadata', function () { if (k === i) programa(); });
    });
    function despierta() { if (aLaVista(caja, 1) && vids[i].paused) arranca(vids[i]); }
    window.addEventListener('scroll', despierta, { passive: true });
    document.addEventListener('visibilitychange', despierta);
    despierta();
    programa();
    return function () {
      clearTimeout(reloj); clearTimeout(cambio);
      window.removeEventListener('scroll', despierta);
      document.removeEventListener('visibilitychange', despierta);
    };
  }

  /* ---------- linea temporal: se enciende año por año al llegar (escritorio) ---------- */
  function linea(tl) {
    var cols = arr(tl.querySelectorAll('.bt-yr-col'));
    if (!cols.length) return null;
    var scroller = tl.closest('.bt-tl-scroll');
    var i = 0, timer = null, arrancado = false;

    function show(k) {
      i = k;
      cols.forEach(function (c, x) { c.classList.toggle('is-active', x === k); c.classList.toggle('is-done', x < k); });
      if (scroller && scroller.scrollWidth > scroller.clientWidth) {
        var c = cols[k];
        scroller.scrollTo({ left: c.offsetLeft - scroller.clientWidth / 2 + c.offsetWidth / 2, behavior: 'smooth' });
      }
    }
    function fin() {
      if (timer) { clearInterval(timer); timer = null; }
      tl.classList.remove('is-seq');
      cols.forEach(function (c) { c.classList.remove('is-active', 'is-done'); });
    }
    cols.forEach(function (c, k) {
      c.addEventListener('click', function () {
        if (timer) { clearInterval(timer); timer = null; }
        arrancado = true; tl.classList.add('is-seq'); show(k);
      });
    });
    function arranca() {
      if (arrancado || esMovil() || !aLaVista(tl, 0.8)) return;
      arrancado = true;
      window.removeEventListener('scroll', arranca);
      tl.classList.add('is-seq');
      show(0);
      timer = setInterval(function () { if (i >= cols.length - 1) { fin(); return; } show(i + 1); }, 2200);
    }
    if (!reduce) { window.addEventListener('scroll', arranca, { passive: true }); setTimeout(arranca, 300); }
    return function () { if (timer) clearInterval(timer); window.removeEventListener('scroll', arranca); };
  }

  /* ---------- linea temporal en movil: un año, su proyecto destacado, y va pasando ---------- */
  function carrusel(mini) {
    var sec = mini.closest('.bt-aportado');
    if (!sec) return null;
    var datos = arr(sec.querySelectorAll('.bt-yr-col')).map(function (col) {
      var fichas = arr(col.querySelectorAll('.bt-ti'));
      var elegida =
        fichas.filter(function (t) { return t.hasAttribute('data-destacado'); })[0] ||
        fichas.filter(function (t) { return t.classList.contains('is-star') && t.querySelector('img'); })[0] ||
        fichas.filter(function (t) { return t.querySelector('img'); })[0] ||
        fichas.filter(function (t) { return t.classList.contains('is-star'); })[0] ||
        fichas[0];
      var y = col.querySelector('.bt-yr');
      return { anyo: y ? y.textContent.trim() : '', ficha: elegida };
    }).filter(function (d) { return d.ficha; });
    if (datos.length < 2) return null;

    var TURNO = 4200;
    mini.innerHTML = '';
    var anyos = document.createElement('div'); anyos.className = 'bt-tm-years';
    var barra = document.createElement('div'); barra.className = 'bt-tm-bar';
    var relleno = document.createElement('i'); barra.appendChild(relleno);
    var caja = document.createElement('div'); caja.className = 'bt-tm-card';
    datos.forEach(function (d, k) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bt-tm-y'; b.textContent = d.anyo;
      b.addEventListener('click', function () { ir(k); });
      anyos.appendChild(b);
    });
    mini.appendChild(anyos); mini.appendChild(barra); mini.appendChild(caja);

    var i = 0, reloj = null, cambio = null, vivo = false;
    function pinta(k, seco) {
      // el año y la ficha cambian a la vez: si no, en el fundido no cuadran
      function mete() {
        arr(anyos.children).forEach(function (b, j) { b.classList.toggle('on', j === k); });
        caja.innerHTML = '';
        caja.appendChild(datos[k].ficha.cloneNode(true));
        caja.classList.remove('is-out');
      }
      clearTimeout(cambio);
      if (seco) { mete(); return; }
      caja.classList.add('is-out');
      cambio = setTimeout(mete, 260);
    }
    function cuenta() {
      relleno.style.transition = 'none'; relleno.style.width = '0%';
      void relleno.offsetWidth;
      relleno.style.transition = 'width ' + (TURNO / 1000) + 's linear'; relleno.style.width = '100%';
    }
    function ir(k) {
      i = k; pinta(k); cuenta();
      clearTimeout(reloj);
      reloj = setTimeout(function () { ir((i + 1) % datos.length); }, TURNO);
    }
    pinta(0, true);
    function mira() {
      if (esMovil() && aLaVista(sec)) { if (!vivo) { vivo = true; ir(i); } }
      else if (vivo) { vivo = false; clearTimeout(reloj); relleno.style.transition = 'none'; relleno.style.width = '0%'; }
    }
    window.addEventListener('scroll', mira, { passive: true });
    window.addEventListener('resize', mira);
    mira();
    return function () {
      clearTimeout(reloj); clearTimeout(cambio);
      window.removeEventListener('scroll', mira); window.removeEventListener('resize', mira);
    };
  }

  /* ---------- opiniones en movil: una cada vez, con flechas, rayitas y deslizando ---------- */
  function opiniones(view) {
    var track = view.querySelector('.bt-revs');
    var cards = track ? arr(track.children) : [];
    var nav = view.parentElement.querySelector('.bt-revs-nav');
    if (cards.length < 2 || !nav) return null;
    var dots = arr(nav.querySelectorAll('.bt-revs-dots button'));
    var prev = nav.querySelector('.bt-revs-prev'), next = nav.querySelector('.bt-revs-next');
    var i = 0, auto = null, tocado = false;

    function paso() {
      var hueco = parseFloat(getComputedStyle(track).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + hueco;
    }
    // en movil se ve una opinion; en escritorio, si la seccion lo pide, se ven varias y van pasando
    function movil() { return esMovil(); }
    function activo() { return movil() || !!view.closest('.bt-revs--carrusel'); }
    function porPagina() {
      var ancho = paso();
      return ancho > 0 ? Math.max(1, Math.round(view.clientWidth / ancho)) : 1;
    }
    function tope() { return Math.max(0, cards.length - porPagina()); }
    function pinta() {
      if (!activo()) { track.style.transform = ''; dots.forEach(function (d) { d.style.display = ''; }); return; }
      if (i > tope()) i = tope();
      track.style.transform = 'translateX(' + (-i * paso()) + 'px)';
      dots.forEach(function (d, k) {
        d.style.display = k > tope() ? 'none' : '';
        d.classList.toggle('on', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }
    function parar() { tocado = true; if (auto) { clearInterval(auto); auto = null; } }
    function ir(k, aMano) { var n = tope() + 1; i = (k + n) % n; pinta(); if (aMano) parar(); }

    prev.addEventListener('click', function () { ir(i - 1, true); });
    next.addEventListener('click', function () { ir(i + 1, true); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { ir(k, true); }); });

    // deslizar: solo cuenta si el gesto es mas horizontal que vertical, para no estorbar al scroll de la pagina
    var x0 = null, y0 = 0, dx = 0, horizontal = false;
    view.addEventListener('touchstart', function (e) {
      if (!movil()) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; horizontal = false;
    }, { passive: true });
    view.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (!horizontal && Math.abs(mx) > 8 && Math.abs(mx) > Math.abs(my)) { horizontal = true; track.style.transition = 'none'; }
      if (horizontal) { dx = mx; track.style.transform = 'translateX(' + (-i * paso() + dx) + 'px)'; }
    }, { passive: true });
    view.addEventListener('touchend', function () {
      if (x0 === null) return;
      track.style.transition = '';
      if (horizontal && Math.abs(dx) > 40) ir(dx < 0 ? i + 1 : i - 1, true); else pinta();
      x0 = null;
    });

    window.addEventListener('resize', pinta);
    if (!reduce) auto = setInterval(function () { if (!tocado && activo() && aLaVista(view)) ir(i + 1); }, 7000);
    pinta();
    return function () { if (auto) clearInterval(auto); window.removeEventListener('resize', pinta); track.style.transform = ''; };
  }

  /* ---------- tienda: el explorador (elegir un equipo cambia el escaparate) ---------- */
  function cuentaCifras(panel) {
    if (reduce || !panel) return;
    // solo las cifras con unidad (2.4 TH/s, 30 W, 12.5 J/TH...): el resto se queda tal cual
    arr(panel.querySelectorAll('.bt-exp-spec b')).forEach(function (b) {
      var original = b.getAttribute('data-v') || b.textContent;
      b.setAttribute('data-v', original);
      var m = original.match(/^(\d+(?:\.\d+)?)(\s*(?:TH\/s|GH\/s|KH\/s|W|J\/TH))$/);
      if (!m) return;
      var fin = parseFloat(m[1]), dec = (m[1].split('.')[1] || '').length, t0 = null, hecho = false;
      function paso(t) {
        if (hecho) return;
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 700), e = 1 - Math.pow(1 - k, 3);
        b.textContent = (fin * e).toFixed(dec) + m[2];
        if (k < 1) requestAnimationFrame(paso); else { hecho = true; b.textContent = original; }
      }
      requestAnimationFrame(paso);
      // seguro: si el navegador congela la animacion (pestaña en segundo plano), el dato final queda puesto igual
      setTimeout(function () { hecho = true; b.textContent = original; }, 900);
    });
  }

  function explorador(sec) {
    var tabs = arr(sec.querySelectorAll('.bt-exp-tab'));
    var panels = arr(sec.querySelectorAll('.bt-exp-panel'));
    var rels = arr(sec.querySelectorAll('.bt-exp-rel'));
    var filas = arr(sec.querySelectorAll('.bt-cmp-row[data-i]'));
    var cmp = sec.querySelector('.bt-cmp');
    if (!tabs.length || tabs.length !== panels.length) return null;
    var actual = 0;

    function elige(k, foco) {
      actual = k;
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === k ? 'true' : 'false'); t.tabIndex = j === k ? 0 : -1; });
      panels.forEach(function (p, j) { p.classList.toggle('on', j === k); });
      // el visor 360 del elegido empieza a cargar ya, sin esperar a su bucle de animacion
      var v = panels[k].querySelector('.bt-360');
      if (v && v.__btCarga) v.__btCarga();
      rels.forEach(function (r) { r.classList.toggle('on', +r.getAttribute('data-i') === k); });
      filas.forEach(function (f) { f.classList.toggle('on', +f.getAttribute('data-i') === k); });
      cuentaCifras(panels[k]);
      if (foco) tabs[k].focus();
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { elige(k); }); });
    var rail = sec.querySelector('.bt-exp-rail');
    rail.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      elige((actual + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length, true);
    });
    // pulsar una fila de la comparativa elige ese equipo y sube al escaparate
    filas.forEach(function (f) {
      f.addEventListener('click', function () {
        elige(+f.getAttribute('data-i'));
        var r = rail.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.5) window.scrollTo({ top: window.scrollY + r.top - 140, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    // en el editor, al pinchar un bloque se muestra ese
    sec.addEventListener('shopify:block:select', function (e) { var k = panels.indexOf(e.target); if (k > -1) elige(k); });
    // las barras de la comparativa crecen la primera vez que se ven
    function mira() {
      if (cmp && aLaVista(cmp, 0.9)) {
        cmp.classList.add('visto');
        window.removeEventListener('scroll', mira); window.removeEventListener('resize', mira);
      }
    }
    if (cmp) { window.addEventListener('scroll', mira, { passive: true }); window.addEventListener('resize', mira); mira(); }
    elige(0);
    return function () {
      if (relojFoto) clearInterval(relojFoto);
      window.removeEventListener('scroll', mira); window.removeEventListener('resize', mira);
    };
  }

  /* ---------- visor 360: 36 fotogramas en una imagen de 6x6; se gira arrastrando ---------- */
  function giro360(el) {
    var src = el.getAttribute('data-sprite'), N = +el.getAttribute('data-frames') || 36, cols = +el.getAttribute('data-cols') || 6;
    var filasS = Math.ceil(N / cols), i = 0, cargado = false, listo = false, raf = null, ultimo = 0, drag = null, pausa = 0;
    var panel = el.closest('.bt-exp-panel'), escenario = el.closest('.bt-exp-stage');
    el.style.backgroundSize = (cols * 100) + '% ' + (filasS * 100) + '%';
    function pinta() {
      var c = i % cols, f = Math.floor(i / cols);
      el.style.backgroundPosition = (c / (cols - 1) * 100) + '% ' + (f / (filasS - 1) * 100) + '%';
    }
    function carga() {
      if (cargado) return; cargado = true;
      var im = new Image();
      im.onload = function () { el.style.backgroundImage = 'url("' + src + '")'; pinta(); listo = true; el.classList.add('ready'); };
      im.src = src;
    }
    function activo() { return (!panel || panel.classList.contains('on')) && aLaVista(el, 1.1); }
    function tick(t) {
      raf = requestAnimationFrame(tick);
      if (!activo()) return;
      carga();
      // gira solo, despacio, mientras nadie lo toca
      if (!listo || drag || reduce || t < pausa) return;
      if (t - ultimo > 95) { ultimo = t; i = (i + 1) % N; pinta(); }
    }
    el.addEventListener('pointerdown', function (e) {
      if (!listo) return;
      drag = { x: e.clientX, i0: i };
      el.classList.add('arrastrando'); if (escenario) escenario.classList.add('tocado');
      try { el.setPointerCapture(e.pointerId); } catch (x) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var paso = Math.max(6, el.clientWidth / 60);          // ~60 px de arrastre por vuelta de 1/6
      i = ((drag.i0 - Math.round((e.clientX - drag.x) / paso)) % N + N) % N;
      pinta();
    });
    function suelta() { if (!drag) return; drag = null; el.classList.remove('arrastrando'); pausa = performance.now() + 2500; }
    el.addEventListener('pointerup', suelta);
    el.addEventListener('pointercancel', suelta);
    el.__btCarga = carga;
    if (panel && panel.classList.contains('on')) carga();
    raf = requestAnimationFrame(tick);
    return function () { cancelAnimationFrame(raf); };
  }

  /* ---------- barra de categorias: se queda debajo de la cabecera y marca donde estas ---------- */
  function barraCategorias(nav) {
    var envoltorio = nav.closest('.shopify-section') || nav;
    var links = arr(nav.querySelectorAll('a[href^="#"]'));
    var destinos = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    function altoCabecera() {
      var h = document.querySelector('.header-sections, .shopify-section-group-group-header');
      if (!h) return 0;
      var cs = getComputedStyle(h);
      return (cs.position === 'sticky' || cs.position === 'fixed') ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
    }
    function mira() {
      var top = altoCabecera();
      envoltorio.style.setProperty('--bt-top', top + 'px');
      document.documentElement.style.setProperty('--bt-top', top + 'px');
      var linea = top + nav.offsetHeight + 90, k = -1;
      destinos.forEach(function (d, j) { if (d && d.getBoundingClientRect().top <= linea) k = j; });
      links.forEach(function (a, j) { a.classList.toggle('on', j === k); });
    }
    links.forEach(function (a, j) {
      a.addEventListener('click', function (e) {
        var d = destinos[j]; if (!d) return;
        e.preventDefault();
        var y = window.scrollY + d.getBoundingClientRect().top - altoCabecera() - nav.offsetHeight - 12;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
      });
    });
    window.addEventListener('scroll', mira, { passive: true });
    window.addEventListener('resize', mira);
    mira();
    return function () { window.removeEventListener('scroll', mira); window.removeEventListener('resize', mira); };
  }

  /* ---------- familias: la fila elige familia, debajo la banda y todo lo suyo ---------- */
  function familias(panels) {
    var sec = panels.closest('.bt-fam') || panels.parentNode;
    var tabs = arr(sec.querySelectorAll('.bt-fam-tab'));
    var hojas = arr(panels.querySelectorAll('.bt-fam-panel'));
    var filas = arr(sec.querySelectorAll('.bt-cmp-row[data-i]'));
    var cmp = sec.querySelector('.bt-cmp');
    if (!tabs.length || tabs.length !== hojas.length) return null;
    var actual = 0;

    // si la familia tiene varias fotos del equipo, se van turnando solas
    var relojFoto = null;
    function turnaFotos(k) {
      if (relojFoto) { clearInterval(relojFoto); relojFoto = null; }
      var caja = hojas[k].querySelector('.bt-fam-shot');
      if (!caja || reduce) return;
      var ims = arr(caja.querySelectorAll('img'));
      if (ims.length < 2) return;
      var j = 0;
      ims.forEach(function (x, q) { if (x.classList.contains('on')) j = q; });
      relojFoto = setInterval(function () {
        if (!aLaVista(caja, 1)) return;
        j = (j + 1) % ims.length;
        ims.forEach(function (x, q) { x.classList.toggle('on', q === j); });
      }, 5200);
    }

    function elige(k, foco) {
      actual = k;
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === k ? 'true' : 'false'); t.tabIndex = j === k ? 0 : -1; });
      hojas.forEach(function (p, j) { p.classList.toggle('on', j === k); });
      filas.forEach(function (f) { f.classList.toggle('on', +f.getAttribute('data-i') === k); });
      cuentaCifras(hojas[k]);
      turnaFotos(k);
      if (foco) tabs[k].focus();
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { elige(k); }); });
    var rail = sec.querySelector('.bt-fam-rail');
    if (rail) rail.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      elige((actual + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length, true);
    });
    // pulsar una fila de la comparativa abre esa familia y sube a la fila de arriba
    filas.forEach(function (f) {
      f.addEventListener('click', function () {
        elige(+f.getAttribute('data-i'));
        if (!rail) return;
        var r = rail.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.5) window.scrollTo({ top: window.scrollY + r.top - 140, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    // en el editor, al pinchar un bloque se muestra esa familia
    sec.addEventListener('shopify:block:select', function (e) {
      var k = hojas.indexOf(e.target);
      if (k < 0) { var p = e.target.closest ? e.target.closest('.bt-fam-panel') : null; k = p ? hojas.indexOf(p) : -1; }
      if (k > -1) elige(k);
    });
    // las barras de la comparativa crecen la primera vez que se ven
    function mira() {
      if (cmp && aLaVista(cmp, 0.9)) {
        cmp.classList.add('visto');
        window.removeEventListener('scroll', mira); window.removeEventListener('resize', mira);
      }
    }
    if (cmp) { window.addEventListener('scroll', mira, { passive: true }); window.addEventListener('resize', mira); mira(); }
    elige(0);
    return function () { window.removeEventListener('scroll', mira); window.removeEventListener('resize', mira); };
  }

  /* ---------- destacado de cabecera: varios productos que se van pasando ---------- */
  function destacados(caja) {
    var items = arr(caja.querySelectorAll('.bt-dest-item'));
    if (items.length < 2) return null;
    var i = 0, timer = null;
    var pausa = parseInt(caja.getAttribute('data-pausa') || '5000', 10);
    function go(n) { i = n; items.forEach(function (it, k) { it.classList.toggle('on', k === n); }); }
    function parar() { if (timer) { clearInterval(timer); timer = null; } }
    function andar() { parar(); if (!reduce) timer = setInterval(function () { go((i + 1) % items.length); }, pausa); }
    // si lo esta mirando o lo tiene seleccionado en el editor, no se le escapa
    caja.addEventListener('mouseenter', parar);
    caja.addEventListener('mouseleave', andar);
    caja.addEventListener('shopify:block:select', function (e) { var k = items.indexOf(e.target); if (k > -1) { go(k); parar(); } });
    caja.addEventListener('shopify:block:deselect', andar);
    andar();
    return function () { parar(); };
  }

  var piezas = [
    ['.bt-rot', banner],
    ['.bt-video-box', relevo],
    ['.bt-tl', linea],
    ['.bt-tl-mini', carrusel],
    ['.bt-revs-view', opiniones],
    ['.bt-exp-panels', function (el) { return explorador(el.closest('.bt-exp')); }],
    ['.bt-360', giro360],
    ['.bt-fam-panels', familias],
    ['.bt-snav', barraCategorias],
    ['.bt-dest-rot', destacados]
  ];
  function iniciar(raiz) {
    piezas.forEach(function (p) {
      var els = arr(raiz.querySelectorAll(p[0]));
      if (raiz.matches && raiz.matches(p[0])) els.push(raiz);
      els.forEach(function (el) {
        if (el.__btParar) return;
        el.__btParar = p[1](el) || function () {};
      });
    });
  }
  function parar(raiz) {
    piezas.forEach(function (p) {
      arr(raiz.querySelectorAll(p[0])).forEach(function (el) { if (el.__btParar) { el.__btParar(); el.__btParar = null; } });
    });
  }

  window.BTHome = { iniciar: iniciar, parar: parar };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
  else iniciar(document);
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { parar(e.target); });
})();
